import { render, staticRenderFns } from "./VuetifyWrapper.vue?vue&type=template&id=4d5d9d33&scoped=true"
import script from "./VuetifyWrapper.vue?vue&type=script&lang=js"
export * from "./VuetifyWrapper.vue?vue&type=script&lang=js"
import style0 from "./VuetifyWrapper.vue?vue&type=style&index=0&id=4d5d9d33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d9d33",
  null
  
)

export default component.exports